// 后端搜索类型，以及结果页类型
export const SEARCH_TYPE = {
    cdr: 'CDR',
    // 从analytics返回
    analytics: 'ANALYTICS',
    motif: 'MOTIF',
    fragmentSize: 'FRAGMENT_SIZE',
    fragmentMulti: 'FRAGMENT_MULTI',
    sequence: 'MANUAL',
    short: 'SHORT',
    antibody: 'ANTIBODY',
    degenerate: 'DEGENERATE',
};
// 前端搜索tab类型
export const SEARCH_TYPES = {
    sequence: 'sequence',
    short: 'short',
    cdr: 'cdr',
    motif: 'motif',
    motif2: 'motif2',
    fragment: 'fragment',
    advanced: 'advanced',
    antibody: 'antibody',
    combined: 'combined',
    degenerate: 'degenerate',
};

export const SEARCH_TYPE_BE_TO_FE = {
    CDR: 'cdr',
    ANALYTICS: 'sequence',
    MANUAL: 'sequence',
    SHORT: 'short',
    MOTIF: 'motif',
    MOTIF2: 'motif2',
    FRAGMENT_SIZE: 'fragment',
    FRAGMENT_MULTI: 'fragment',
    ANTIBODY: 'antibody',
    COMBINED: 'combined',
    DEGENERATE: 'degenerate',
};

export const SEARCH_TYPE_TO_USER_SETTING_TYPE = {
    sequence: 'BIO_MANUAL_SEARCH',
    short: 'BIO_SHORT_SEARCH',
    cdr: 'BIO_CDR_SEARCH',
    motif: 'BIO_MOTIF_SEARCH',
    advanced: '',
    fragment: 'BIO_FRAGMENT_SEARCH',
    antibody: 'BIO_ANTIBODY_SEARCH',
    degenerate: 'BIO_DEGENERATE_SEARCH',
};

export const TYPE_PROTEIN = 'protein';
export const TYPE_NUCLEOTIDE = 'nucleotide';
export const ABST_PROTEIN = 'PROTEIN';
export const ABST_NUC = 'NUCLEOTIDE';
export const NUCLEOTIDES_DB = 'NUCLEOTIDE';
export const PROTEIN_DB = 'PROTEIN';
export const CODE_PROTEIN = 1;
export const CODE_NUCLEOTIDE = 0;
export const UNIT_PROTEIN = 'aa';
export const UNIT_NUCLEOTIDE = 'nt';

// sequence types 请使用下方的SEQUENCE_TYPE, 不要再使用这个SEQUENCE_TYPES !!!!!!!!!
export const SEQUENCE_TYPES = [ABST_NUC, ABST_PROTEIN];

// database types
export const DATABASE_TYPES = [NUCLEOTIDES_DB, PROTEIN_DB];
